module.exports = __webpack_public_path__ + "static/media/bg6.8c05ac6b.jpg";